import { ComponentType, getColorByComponentType, Icon } from '@gcl/react-core';
import * as React from 'react';
import { ITag } from 'src/tag/tag.models';
import { RenderTagContentFn } from './TagView';
import './TagView.scss';

interface ITagProps {
  tag?: ITag;
  content?: string;
  onRemove?: (index: number) => void;
  index: number;
  componentType?: ComponentType;
  onRenderTagContent?: RenderTagContentFn;
  className?: string;
}
export const TagItemView: React.FunctionComponent<ITagProps> = ({
  tag,
  onRemove,
  index,
  content,
  componentType = ComponentType.Light,
  onRenderTagContent,
  className = '',
}) => {
  const getLabel = () => {
    let label = '';
    if (!tag) {
      return content;
    }
    if (tag.tagTypeId) {
      label = `${tag.tagTypeName}: `;
    }
    label = label.concat(tag.name);
    return label;
  };

  const onClickRemove = () => {
    if (!onRemove) {
      return;
    }
    onRemove(index);
  };

  const tagLabel =
    onRenderTagContent && typeof onRenderTagContent === 'function' ? onRenderTagContent(tag) : getLabel();

  const fontComponentType = ComponentType.Dark; // componentType === ComponentType.Light ? ComponentType.Dark : ComponentType.Light;

  return (
    <div
      className={`gcl-gems-tag-item ${className}`}
      style={{
        backgroundColor: getColorByComponentType(componentType),
        // color: getColorByComponentType(fontComponentType),
      }}
    >
      <div className="gcl-gems-tag-item-transbox" />
      <div className="gcl-gems-tag-item-content-container">
        <Icon componentType={fontComponentType} iconName="Tag" className="gcl-gems-tag-item-tag-icon" />
        <span className="gcl-gems-tag-content">{tagLabel}</span>
        {onRemove && (
          <Icon
            componentType={fontComponentType}
            iconName="X"
            className="gcl-gems-tag-item-remove-icon-btn"
            onClick={onClickRemove}
          />
        )}
      </div>
    </div>
  );
};
